import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"
import placeholder from 'images/enterprise.png'
import BusinessUnitDeleteModal from "./BusinessUnitDeleteModal"

const BusinessUnitCard = ({
    businessUnitInfo,
    onlyRead = true,
    onFocus = () => { },
    onDelete = () => { }
}) => {

    const [t] = useTranslation("global")


    return (
        <div className="col" key={businessUnitInfo.businessUnit.guid} >

            <div className="card text-white bg-dark">
                <img src={placeholder} className="card-img-top" style={{ background: '#212529' }} alt="..." />
                <div className="card-body">
                    <h5 className="card-title">{businessUnitInfo.businessUnit.name}</h5>
                    <div className="row">
                        <div className="col-auto">
                            <p className="text-muted py-2">
                                <i className="fas fa-users"></i> {businessUnitInfo.employeesCount}
                            </p>
                        </div>
                        <div className="col-auto text-accent py-2">
                            {businessUnitInfo.businessUnit.gps && <i className="fa-solid fa-location-dot"></i>}
                        </div>
                    </div>

                    {
                        onlyRead ?
                            <NavLink to={"/dashboard/businessUnits/detail"} state={businessUnitInfo.businessUnit} className="btn btn-primary"><i className="fa-solid fa-eye" ></i> {t("action.see")}</NavLink>
                            :
                            <>
                                <div className="btn-group" onMouseOver={() => onFocus(businessUnitInfo)}>
                                    <NavLink to={"/dashboard/businessUnits/detail"} state={businessUnitInfo.businessUnit} className="btn btn-primary"><i className="fa-solid fa-eye" ></i> {t("action.see")}</NavLink>

                                    <button type="button" className="btn btn-primary dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                                        <span className="visually-hidden">Toggle Dropdown</span>
                                    </button>
                                    <ul className="dropdown-menu">
                                        <li> <NavLink to={"/dashboard/businessUnits/edit"} state={businessUnitInfo.businessUnit.guid} className="dropdown-item"><i className="fa-solid fa-pen"></i> {t("action.edit")}</NavLink></li>
                                        <li><button className="dropdown-item" data-bs-toggle="modal" data-bs-target={`#delete${businessUnitInfo.businessUnit.code}`}><i className="fa-solid fa-trash"></i> {t("action.delete")}</button></li>
                                    </ul>
                                </div>
                            </>
                    }


                    <BusinessUnitDeleteModal modalId={`delete${businessUnitInfo.businessUnit.code}`} businessUnitInfo={businessUnitInfo} onDelete={onDelete} />

                </div>
                <div className="card-footer">
                    <small className="text-muted">{businessUnitInfo.businessUnit.code}</small>
                </div>
            </div>

        </div>
    )
}

export default BusinessUnitCard